// Copyright (c) 2024 by Audere
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import { SxProps, Theme } from "@mui/material";

export type StyleSheet = { [key: string]: SxProps<Theme> };

export const createStyleSheet = (styles: StyleSheet) => styles;

export const globalStyles = createStyleSheet({
  flexSpace: {
    flex: 1,
  },
  smallGapRight: {
    marginRight: 1,
  },
  gapTop: {
    marginTop: 2,
  },
});

export const combineSx = (sx1: SxProps<Theme>, sx2?: SxProps<Theme>) =>
  !sx2
    ? sx1
    : ([
        ...(Array.isArray(sx1) ? sx1 : [sx1]),
        ...(Array.isArray(sx2) ? sx2 : [sx2]),
      ] as SxProps<Theme>);
